import React, { Component } from 'react';

import { connect } from 'react-redux';
import { Drawer } from 'rsuite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import Dropdown from 'react-bootstrap/Dropdown';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import DataTable from '../../components/DataTable/DataTable';
import {
  PageHeader,
  Pagination,
  NewSubMerchantModal,
  MerchantFilterModal,
  EditMerchantModal,
} from '../../components';
import { getAllMerchant } from '../../api/merchant';
import {
  getSubMerchantsByMerchant,
  addNewSubmerchant,
  updateSubMerchant,
} from '../../api/subMerchant';
import Search from '../../components/Search/Search.component';
import './ViewMerchants.scss';
import CheckableDataTable from '../../components/CheckableDataTable/CheckableDataTable';
import { printTerminals } from '../../api/Terminal';
import moment from 'moment';
import FileSaver from 'file-saver';
import { toast } from 'react-toastify';
import SelectedTerminalsModal from '../../components/Modals/SelectedTerminalsModal';

// ViewMerchants: Main screen for managing merchants and sub-merchants
class ViewMerchants extends Component {
  state = {
    // UI and data state for merchants and sub-merchants
    loading: true,
    tableData: [],
    tableheading: {
      header: 'MERCHANTS',
      column: ['ID', 'Name', 'Category', 'Status', 'Website', 'Contact'],
    },
    fetchError: '',
    dataToRender: [],
    slicedData: [],
    merchantPages: 0,
    total: 1,
    mainCurrent: 0,
    current: 0,
    merchantDrawer: false,
    submerchantsData: [],
    subMerchantTableheading: {
      header: 'SUB MERCHANTS',
      column: ['ID', 'Email', 'Mobile', 'Location', 'T'],
    },
    subMerchantFetchError: '',
    selectedMerchant: null,
    selectedMerchantId: null,
    showModal: false,
    showTerminalDetailsModal: false,
    terminalQuantities: {},
    email: '',
    location: '',
    merchantPin: '',
    validated: false,
    addError: null,
    addIsSuccess: false,
    addApiCalling: false,
    searchedMerchantMessage: null,
    pinError: null,
    pinType: 'password',
    emailError: null,
    slicedSubMerchants: [],
    subMerchantPage: 0,
    successMessage: null,
    terminalsCount: 0,
    showFilterModal: false,
    filterData: {
      byStatus: false,
      status: true,
    },
    selectedSubMerchants: [],
    terminalToPrint: [],
    subMerchantRows: [],
    showEditMerchantModal: false,
    merchantToEdit: null,
    categoryList: [],
    statusList: [],
    queueMerchantId: null,
  };

  // Fetch all merchants and initialize lists
  componentWillMount() {
    getAllMerchant(this.props.auth.token)
      .then((response) => {
        const sortedData = this.sortMerchantList(response);
        // Extract unique categories and statuses
        const categorySet = new Set();
        const statusSet = new Set();
        sortedData.forEach((merchant) => {
          if (merchant.category) categorySet.add(merchant.category);
          if (merchant.status) statusSet.add(merchant.status);
        });
        // Sort the lists alphabetically
        const categoryList = Array.from(categorySet).sort((a, b) =>
          a.localeCompare(b)
        );
        const statusList = Array.from(statusSet).sort((a, b) =>
          a.localeCompare(b)
        );
        this.setState({
          tableData: sortedData,
          loading: false,
          merchantPages: this.getPageCount(sortedData),
          dataToRender: sortedData,
          slicedData: sortedData.slice(0, 10),
          categoryList,
          statusList,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  }

  // Utility: parse and increment merchant ID
  parseInt = (id) => {
    return parseInt(id.substring(0), 10) + 1;
  };

  // Sort merchants by ID
  sortMerchantList = (data) => {
    return data.sort((a, b) => (parseInt(a.id) > parseInt(b.id) ? 1 : -1));
  };

  // Calculate number of pages for pagination
  getPageCount = (data) => {
    let merchantPage = 0;

    const mod = data.length % 10;

    if (mod > 0) {
      merchantPage = data.length / 10 - mod / 10 + 1;
    } else {
      merchantPage = data.length / 10;
    }

    return merchantPage;
  };

  // Search merchants by name
  handleMerchantNameSearch = (name) => {
    if (name) {
      const item = this.state.tableData.filter((item) => {
        let itemData = item.name.toLowerCase();
        return itemData.indexOf(name.toLowerCase()) > -1;
      });

      this.setState({
        dataToRender: item,
        slicedData: item.slice(0, 10),
        merchantPages: this.getPageCount(item),
        searchedMerchantMessage: `found for name ${name}`,
      });
    }
  };

  // Search merchants by ID
  handleMerchantSearch = (id) => {
    if (id) {
      const item = this.state.tableData.filter((item) => item.id === id);

      this.setState({
        dataToRender: item,
        slicedData: item.slice(0, 10),
        merchantPages: this.getPageCount(item),
        searchedMerchantMessage: `id found for ${id}`,
      });
    }
  };

  // Reset merchant search
  handlMerchantsclear = () => {
    this.setState({
      dataToRender: this.state.tableData,
      slicedData: this.state.tableData.slice(0, 10),
      merchantPages: this.getPageCount(this.state.tableData),
      searchedMerchantMessage: null,
    });
  };

  // Toggle PIN text visibility
  handleTextVisibility = () => {
    if (this.state.pinType === 'password') {
      this.setState({ pinType: 'text' });
    } else {
      this.setState({ pinType: 'password' });
    }
  };

  // Handle merchant pagination
  handleMerchantpagination = (page) => {
    if (page > 0) {
      const sliceStart = page * 10;
      const sliceEnd = (page + 1) * 10;
      this.setState({
        slicedData: this.state.dataToRender.slice(sliceStart, sliceEnd),
      });
    } else {
      const sliceStart = 0;
      const sliceEnd = 10;
      this.setState({
        slicedData: this.state.dataToRender.slice(sliceStart, sliceEnd),
      });
    }
  };

  // Handle sub-merchant pagination
  handleSubMerchantPagination = (page) => {
    let sliceStart = 0;
    let sliceEnd = 10;
    if (page > 0) {
      sliceStart = page * 10;
      sliceEnd = (page + 1) * 10;
    }
    this.setState({
      slicedSubMerchants: this.state.submerchantsData.slice(
        sliceStart,
        sliceEnd
      ),
    });
  };

  // Manage selected sub-merchants
  handleSelectedSubMerchants = (newSelectedSubMerchants) => {
    return this.setState({ selectedSubMerchants: newSelectedSubMerchants });
  };

  // Toggle selection for a sub-merchant
  handleCheckSubMerchants = (id) => {
    const {
      subMerchantRows,
      selectedSubMerchants,
      submerchantsData,
      selectedMerchant,
    } = this.state;
    const isChecked = subMerchantRows.includes(id);
    let newCheckedRows;
    let newSelectedSubMerchants = [...selectedSubMerchants];

    if (isChecked) {
      newCheckedRows = subMerchantRows.filter((rowId) => rowId !== id);
      newSelectedSubMerchants = newSelectedSubMerchants.filter(
        (item) => item.subMerchantId !== id
      );
    } else {
      newCheckedRows = [...subMerchantRows, id];
      newSelectedSubMerchants.push({
        subMerchantId: id,
        merchantName: selectedMerchant,
        subMerchantLocation: submerchantsData.find((row) => row.id === id)
          ?.location,
        terminals:
          submerchantsData.find((row) => row.id === id)?.terminals || [],
      });
    }

    this.setState({
      subMerchantRows: newCheckedRows,
      selectedSubMerchants: newSelectedSubMerchants,
    });
    this.handleSelectedSubMerchants(newSelectedSubMerchants);
  };

  // Select or deselect all sub-merchants
  handleCheckAllSubMerchants = () => {
    const {
      submerchantsData,
      subMerchantRows,
      selectedSubMerchants,
      selectedMerchant,
    } = this.state;
    const allIds = submerchantsData.map((row) => row.id);
    let newCheckedRows = [...subMerchantRows];
    let newSelectedSubMerchants = [...selectedSubMerchants];

    const allChecked = allIds.every((id) => subMerchantRows.includes(id));
    if (allChecked) {
      // Deselect all for this merchant only
      newCheckedRows = subMerchantRows.filter((id) => !allIds.includes(id));
      newSelectedSubMerchants = selectedSubMerchants.filter(
        (item) => !allIds.includes(item.subMerchantId)
      );
    } else {
      // Add all submerchants for this merchant, avoiding duplicates
      allIds.forEach((id) => {
        if (!newCheckedRows.includes(id)) newCheckedRows.push(id);
        if (
          !newSelectedSubMerchants.some((item) => item.subMerchantId === id)
        ) {
          const row = submerchantsData.find((r) => r.id === id);
          newSelectedSubMerchants.push({
            subMerchantId: id,
            merchantName: selectedMerchant,
            subMerchantLocation: row?.location,
            terminals: row?.terminals || [],
          });
        }
      });
    }
    this.setState({
      subMerchantRows: newCheckedRows,
      selectedSubMerchants: newSelectedSubMerchants,
    });
    this.handleSelectedSubMerchants(newSelectedSubMerchants);
  };

  // Add selected sub-merchants to print queue
  handleTerminalsToPrint = () => {
    const { selectedSubMerchants, terminalToPrint } = this.state;
    // If no sub-merchants are selected, show a message and return
    if (selectedSubMerchants.length === 0) {
      toast.error(
        'No sub-merchants selected for printing. Please select at least one.'
      );
      this.setState({
        selectedSubMerchants: [],
        terminalToPrint: [],
        terminalsCount: 0,
      });
      return;
    }
    // Remove unselected sub-merchants from the queue
    const updatedQueue = terminalToPrint.filter((item) =>
      selectedSubMerchants.some(
        (sel) => sel.subMerchantId === item.subMerchantId
      )
    );
    // Find new sub-merchants to add
    const newSubMerchants = selectedSubMerchants.filter(
      (sel) =>
        !terminalToPrint.some(
          (item) => item.subMerchantId === sel.subMerchantId
        )
    );
    // Find removed sub-merchants
    const removedSubMerchants = terminalToPrint.filter(
      (item) =>
        !selectedSubMerchants.some(
          (sel) => sel.subMerchantId === item.subMerchantId
        )
    );
    // If no new sub-merchants and some were removed, show removal warning
    if (newSubMerchants.length === 0 && removedSubMerchants.length > 0) {
      this.setState({
        terminalToPrint: updatedQueue,
        terminalsCount: updatedQueue.length,
        merchantDrawer: false,
      });
      toast.warning('Removing some sub merchants from the queue.');
      return;
    }
    // If no new sub-merchants and none were removed, show no-new warning
    if (newSubMerchants.length === 0 && removedSubMerchants.length === 0) {
      this.setState({
        terminalToPrint: updatedQueue,
        terminalsCount: updatedQueue.length,
        merchantDrawer: false,
      });
      toast.warning('No new sub-merchants to add to the print queue.');
      return;
    }
    // Replace the queue with the currently selected sub-merchants
    this.setState({
      terminalToPrint: selectedSubMerchants,
      terminalsCount: selectedSubMerchants.length,
      merchantDrawer: false,
    });
  };

  // Toggle terminal details modal
  toggleTerminalDetailsModal = () => {
    this.setState((prevState) => ({
      showTerminalDetailsModal: !prevState.showTerminalDetailsModal,
    }));
  };

  // Clear terminal quantities
  clearTerminalQuantities = () => {
    const newQuantities = Object.keys(this.state.terminalQuantities).reduce(
      (acc, key) => {
        acc[key] = 0;
        return acc;
      },
      {}
    );
    this.setState({ terminalQuantities: newQuantities });
  };

  // Group terminals by merchant for printing
  groupTerminalsByMerchant = () => {
    const grouped = {};

    // Iterate over each terminal and group by merchantName
    this.state.terminalToPrint.forEach((terminal) => {
      const { merchantName, subMerchantLocation } = terminal;

      if (!grouped[merchantName]) {
        grouped[merchantName] = { merchantName, terminals: [] };
      }

      grouped[merchantName].terminals.push({
        ...terminal,
        subMerchantLocation,
      });
    });

    return Object.values(grouped);
  };

  // Update input number for terminals
  handleInputNumberChange = (terminalId, value) => {
    this.setState((prevState) => ({
      terminalQuantities: {
        ...prevState.terminalQuantities,
        [terminalId]: value,
      },
    }));
  };

  // Print terminal quantities (async)
  printTerminalQuantities = async () => {
    try {
      const terminalQuantities = this.state.terminalQuantities;
      const terminalIds = [];

      for (const [terminalId, quantity] of Object.entries(terminalQuantities)) {
        for (let i = 0; i < quantity; i++) {
          terminalIds.push(terminalId);
        }
      }

      const requestBody = {
        terminalIds: terminalIds,
      };

      if (terminalIds.length === 0) {
        toast.error('No terminals selected for printing.');
        return;
      }

      const rawPdfResponse = await printTerminals(
        requestBody,
        this.props.auth.token
      );

      // Decode and save the PDF file
      const decodedPdfData = new Uint8Array(
        Buffer.from(rawPdfResponse, 'base64')
      );
      const blob = new Blob([decodedPdfData], { type: 'application/pdf' });
      const date = new Date();
      const fileName = moment(date).format('DDMMYY-HHmmss');
      FileSaver.saveAs(blob, fileName);
    } catch (error) {
      console.error('Error generating QR codes:', error);
    }
  };

  // Remove a sub-merchant from the print queue
  handleRemoveSubMerchantFromQueue = (subMerchantId) => {
    const {
      terminalToPrint,
      terminalsCount,
      subMerchantRows,
      selectedSubMerchants,
    } = this.state;
    const updatedTerminalToPrint = terminalToPrint.filter(
      (item) => item.subMerchantId !== subMerchantId
    );
    const removedCount = terminalToPrint.filter(
      (item) => item.subMerchantId === subMerchantId
    ).length;
    // Also uncheck the sub-merchant in the drawer table
    const updatedSubMerchantRows = subMerchantRows.filter(
      (id) => id !== subMerchantId
    );
    const updatedSelectedSubMerchants = selectedSubMerchants.filter(
      (item) => item.subMerchantId !== subMerchantId
    );
    this.setState({
      terminalToPrint: updatedTerminalToPrint,
      terminalsCount: terminalsCount - removedCount,
      subMerchantRows: updatedSubMerchantRows,
      selectedSubMerchants: updatedSelectedSubMerchants,
    });
    this.handleSelectedSubMerchants(updatedSelectedSubMerchants);
  };

  // Fetch sub-merchants for a merchant
  handleOnClick = (id) => {
    getSubMerchantsByMerchant(id, this.props.auth.token)
      .then((response) => {
        var submerchantPage = 0;
        var mod = response.subMerchants.length % 10;
        if (mod > 0) {
          submerchantPage = response.subMerchants.length / 10 - mod / 10 + 1;
        } else {
          submerchantPage = response.subMerchants.length / 10;
        }
        this.setState({
          submerchantsData: response.subMerchants,
          merchantDrawer: true,
          selectedMerchant: this.getSelectedMerchant(id),
          selectedMerchantId: id,
          slicedSubMerchants: response.subMerchants.slice(0, 10),
          subMerchantPage: submerchantPage,
        });
      })
      .catch((err) => {
        this.setState({
          submerchantsData: [],
          merchantDrawer: true,
          selectedMerchant: this.getSelectedMerchant(id),
          slicedSubMerchants: [],
        });
      });
  };

  // Get merchant name by ID
  getSelectedMerchant = (id) => {
    const merchant = this.state.tableData.find((data) => data.id === id);
    return merchant ? merchant.name : '';
  };

  // Show/hide merchant drawer
  handleDrawShow = (boolean) => {
    this.setState({
      merchantDrawer: boolean,
    });
  };

  // Open add sub-merchant modal
  handleAddNewSubMerchantOnClick = () => {
    this.handleDrawShow(false);
    this.handleModalShow(true);
  };

  // Show/hide add sub-merchant modal
  handleModalShow = (boolean) => {
    this.setState({
      showModal: boolean,
    });
    if (!boolean) {
      this.setState({
        email: '',
        location: '',
        merchantPin: '',
        addIsSuccess: false,
        validated: false,
        pinError: null,
        emailError: null,
      });
    }
  };

  // Handle input changes for sub-merchant form
  handleOnChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: this.state[name].length === 0 ? value.trim() : value,
      emailError: null,
    });
  };

  // Handle PIN input change
  handlePinOnChange = (event) => {
    this.setState({
      merchantPin: event.target.value.replace(/[^0-9\s]/g, '').trim(),
      pinError: null,
    });
  };

  // Validate email format
  validatedEmail = () => {
    const pattern = /[a-zA-Z0-9]+\.?([a-zA-Z0-9]+)?@[a-zA-Z0-9]{2,9}\.[a-z]{2,5}/g;
    return pattern.test(this.state.email);
  };

  // Filter merchants by status
  handleFilter = ({ byStatus, status }) => {
    let filteredMerchants = this.state.tableData;

    if (byStatus) {
      filteredMerchants = this.state.tableData.filter((merchant) =>
        status
          ? (merchant.status || '').toLowerCase() === 'active'
          : (merchant.status || '').toLowerCase() === 'inactive'
      );
    }

    this.setState({
      dataToRender: filteredMerchants,
      slicedData: filteredMerchants.slice(0, 10),
      merchantPages: this.getPageCount(filteredMerchants),
      showFilterModal: false,
      filterData: { byStatus, status },
      searchedMerchantMessage: filteredMerchants.length ? null : 'found',
    });
  };

  // Add new sub-merchant (form submit)
  handleAddNewSubMerchant = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.setState({
      validated: true,
      addApiCalling: true,
    });

    if (this.state.merchantPin.length === 0) {
      this.setState({
        pinError: 'Merchant pin cannot be empty',
        addApiCalling: false,
      });
    } else {
      if (!this.validatedEmail()) {
        this.setState({
          emailError: 'Enter a valid email address',
          addApiCalling: false,
        });
        return;
      }
      const request = {
        email: this.state.email,
        location: this.state.location,
        mangerPin: this.state.merchantPin,
        merchantId: this.state.selectedMerchantId,
      };
      try {
        const result = await addNewSubmerchant(request, this.props.auth.token);
        this.setState({
          addIsSuccess: true,
          addApiCalling: false,
          successMessage: result.message,
        });
      } catch (err) {
        this.setState({
          addError: 'Failed to add new subMerchant',
          addIsSuccess: false,
          addApiCalling: false,
        });
      }
    }
  };

  // Open terminal link in new tab
  onTerminalClick = (terminal) => {
    const encodedTerminal = btoa(terminal);
    const url = `${process.env.REACT_APP_CUSTOMER_PORTAL_URL}/redeem/${encodedTerminal}`;
    window.open(url, '_blank');
  };

  // Update sub-merchant email
  handleUpdateSubMerchantEmail = async (subMerchantId, newEmails) => {
    try {
      // Don't update if emails are empty
      if (!newEmails || newEmails.length === 0) {
        return;
      }

      const currentSubMerchant = this.state.submerchantsData.find(
        (subMerchant) => subMerchant.id === subMerchantId
      );

      if (currentSubMerchant && JSON.stringify(currentSubMerchant.contactDetails) === JSON.stringify(newEmails)) {
        return;
      }

      // Show loading state
      const loadingSubmerchantsData = this.state.submerchantsData.map(
        (subMerchant) => ({
          ...subMerchant,
          isLoading: subMerchant.id === subMerchantId,
        })
      );

      const loadingSlicedSubMerchants = this.state.slicedSubMerchants.map(
        (subMerchant) => ({
          ...subMerchant,
          isLoading: subMerchant.id === subMerchantId,
        })
      );

      this.setState({
        submerchantsData: loadingSubmerchantsData,
        slicedSubMerchants: loadingSlicedSubMerchants,
      });

      const response = await updateSubMerchant(
        subMerchantId,
        { contactDetails: newEmails },
        this.props.auth.token
      );

      if (response.message === 'sub-merchant details updated successfully') {
        // Update the state with new data
        const updatedSubmerchantsData = this.state.submerchantsData.map(
          (subMerchant) => ({
            ...subMerchant,
            contactDetails: subMerchant.id === subMerchantId ? newEmails : subMerchant.contactDetails,
            isLoading: false,
          })
        );

        const updatedSlicedSubMerchants = this.state.slicedSubMerchants.map(
          (subMerchant) => ({
            ...subMerchant,
            contactDetails: subMerchant.id === subMerchantId ? newEmails : subMerchant.contactDetails,
            isLoading: false,
          })
        );

        this.setState({
          submerchantsData: updatedSubmerchantsData,
          slicedSubMerchants: updatedSlicedSubMerchants,
          successMessage: 'Email updated successfully',
        });

        setTimeout(() => {
          this.setState({ successMessage: null });
        }, 3000);

        toast.success('Email updated successfully');
      }
    } catch (error) {
      console.error('Error updating sub-merchant email:', error);
      // Reset loading state on error
      const resetLoadingData = this.state.submerchantsData.map(
        (subMerchant) => ({
          ...subMerchant,
          isLoading: false,
        })
      );

      const resetLoadingSliced = this.state.slicedSubMerchants.map(
        (subMerchant) => ({
          ...subMerchant,
          isLoading: false,
        })
      );

      this.setState({
        submerchantsData: resetLoadingData,
        slicedSubMerchants: resetLoadingSliced,
      });

      toast.error('Failed to update email');
    }
  };

  // Update sub-merchant mobile
  handleUpdateSubMerchantMobile = async (subMerchantId, newMobiles) => {
    // Get current sub-merchant and store original value immediately
    const currentSubMerchant = this.state.submerchantsData.find(
      (subMerchant) => subMerchant.id === subMerchantId
    );
    const originalContactDetails = currentSubMerchant ? currentSubMerchant.contactDetails : [];

    try {
      // Don't update if mobiles are empty
      if (!newMobiles || newMobiles.length === 0) {
        toast.error('Mobile numbers cannot be empty');
        return;
      }

      if (currentSubMerchant && JSON.stringify(currentSubMerchant.contactDetails) === JSON.stringify(newMobiles)) {
        toast.info('No changes to update');
        return;
      }

      // Show loading state
      const updateLoadingState = (data) => data.map(subMerchant => ({
        ...subMerchant,
        isLoading: subMerchant.id === subMerchantId
      }));

      this.setState({
        submerchantsData: updateLoadingState(this.state.submerchantsData),
        slicedSubMerchants: updateLoadingState(this.state.slicedSubMerchants)
      });

      const response = await updateSubMerchant(
        subMerchantId,
        { contactDetails: newMobiles },
        this.props.auth.token
      );

      if (response.message === 'sub-merchant details updated successfully') {
        // Update state with new contactDetails on success
        const updateSuccessState = (data) => data.map(subMerchant => ({
          ...subMerchant,
          contactDetails: subMerchant.id === subMerchantId ? newMobiles : subMerchant.contactDetails,
          isLoading: false
        }));

        this.setState({
          submerchantsData: updateSuccessState(this.state.submerchantsData),
          slicedSubMerchants: updateSuccessState(this.state.slicedSubMerchants),
          successMessage: 'Mobile number updated successfully'
        });

        setTimeout(() => {
          this.setState({ successMessage: null });
        }, 3000);

        toast.success('Mobile number updated successfully');
      } else {
        // Revert to original value if update fails
        const updateFailureState = (data) => data.map(subMerchant => ({
          ...subMerchant,
          contactDetails: subMerchant.id === subMerchantId ? originalContactDetails : subMerchant.contactDetails,
          isLoading: false
        }));

        this.setState({
          submerchantsData: updateFailureState(this.state.submerchantsData),
          slicedSubMerchants: updateFailureState(this.state.slicedSubMerchants)
        });

        toast.error(response.message || 'Failed to update mobile number');
      }
    } catch (error) {
      console.error('Error updating sub-merchant mobile:', error);

      // Revert to original value on error
      const updateErrorState = (data) => data.map(subMerchant => ({
        ...subMerchant,
        contactDetails: subMerchant.id === subMerchantId ? originalContactDetails : subMerchant.contactDetails,
        isLoading: false
      }));

      this.setState({
        submerchantsData: updateErrorState(this.state.submerchantsData),
        slicedSubMerchants: updateErrorState(this.state.slicedSubMerchants)
      });

      toast.error('Failed to update mobile number');
    }
  };

  // Update sub-merchant location
  handleUpdateSubMerchantLocation = async (subMerchantId, newLocation) => {
    // Get current sub-merchant outside try block so it's available in catch
    const currentSubMerchant = this.state.submerchantsData.find(
      (subMerchant) => subMerchant.id === subMerchantId
    );
    const originalLocation = currentSubMerchant ? currentSubMerchant.location : 'N/A';

    try {

      if (!newLocation || newLocation === 'N/A' || newLocation === '') {
        toast.error('Location cannot be empty');
        return;
      }

      if (currentSubMerchant && currentSubMerchant.location === newLocation) {
        toast.info('No changes to update');
        return;
      }


      // Show loading state for better UX
      const updateLoadingState = (data) => data.map(subMerchant => ({
        ...subMerchant,
        isLoading: subMerchant.id === subMerchantId,
        location: subMerchant.id === subMerchantId ? 'Updating...' : subMerchant.location
      }));

      this.setState({
        submerchantsData: updateLoadingState(this.state.submerchantsData),
        slicedSubMerchants: updateLoadingState(this.state.slicedSubMerchants)
      });

      const response = await updateSubMerchant(
        subMerchantId,
        { location: newLocation },
        this.props.auth.token
      );

      if (response.message === 'sub-merchant details updated successfully') {
        // Update all relevant state with new location
        const updateSuccessState = (data) => data.map(subMerchant => ({
          ...subMerchant,
          isLoading: false,
          location: subMerchant.id === subMerchantId ? newLocation : subMerchant.location
        }));

        const updatedSelectedSubMerchants = this.state.selectedSubMerchants.map(
          item => item.subMerchantId === subMerchantId
            ? { ...item, subMerchantLocation: newLocation }
            : item
        );

        this.setState({
          submerchantsData: updateSuccessState(this.state.submerchantsData),
          slicedSubMerchants: updateSuccessState(this.state.slicedSubMerchants),
          selectedSubMerchants: updatedSelectedSubMerchants
        });

        toast.success('Location updated successfully');
      } else {
        // Revert to original value if update fails
        const updateFailureState = (data) => data.map(subMerchant => ({
          ...subMerchant,
          isLoading: false,
          location: subMerchant.id === subMerchantId ? originalLocation : subMerchant.location
        }));

        this.setState({
          submerchantsData: updateFailureState(this.state.submerchantsData),
          slicedSubMerchants: updateFailureState(this.state.slicedSubMerchants)
        });

        toast.error(response.message || 'Failed to update location');
      }
    } catch (error) {
      console.error('Error updating submerchant location:', error);

      // Revert to original value on error
      const updateErrorState = (data) => data.map(subMerchant => ({
        ...subMerchant,
        isLoading: false,
        location: subMerchant.id === subMerchantId
          ? (currentSubMerchant ? currentSubMerchant.location : 'N/A')
          : subMerchant.location
      }));

      this.setState({
        submerchantsData: updateErrorState(this.state.submerchantsData),
        slicedSubMerchants: updateErrorState(this.state.slicedSubMerchants)
      });

      toast.error('Failed to update location');
    }
  };

  // Open edit merchant modal
  handleEditMerchant = (merchant) => {
    try {
      this.setState({
        showEditMerchantModal: true,
        merchantToEdit: merchant,
      });
    } catch (error) {
      console.error('Error in handleEditMerchant:', error);
    }
  };

  // Close edit merchant modal
  handleEditMerchantModalClose = () => {
    this.setState({
      showEditMerchantModal: false,
      merchantToEdit: null,
    });
  };

  // Refresh merchant data after edit
  handleMerchantUpdateSuccess = () => {
    getAllMerchant(this.props.auth.token)
      .then((response) => {
        const sortedData = this.sortMerchantList(response);
        this.setState({
          tableData: sortedData,
          dataToRender: sortedData,
          slicedData: sortedData.slice(
            this.state.current * 10,
            (this.state.current + 1) * 10
          ),
        });
      })

      .catch((err) => {
        console.error('Error refreshing merchant data:', err);
      });
  };

  // Render dropdown for terminals
  renderTerminalsDropdown = (terminals) => {
    return (
      <Dropdown style={{ cursor: 'pointer' }}>
        <Dropdown.Toggle as='div' className='dropdownToggle' id='dropdown' />
        <Dropdown.Menu>
          {terminals.map((terminal) => {
            return (
              <Dropdown.Item
                key={terminal}
                onSelect={() => this.onTerminalClick(terminal)}
              >
                {terminal}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  // Render sub-merchants drawer
  renderSubMerchantsDrawer = () => {
    // Only show checked rows for the current merchant
    const currentMerchantIds = this.state.submerchantsData.map((row) => row.id);
    const checkedRowsForCurrentMerchant = this.state.subMerchantRows.filter(
      (id) => currentMerchantIds.includes(id)
    );

    // Handlers to pass to CheckableDataTable
    const handleEmailUpdate = (id, newEmails) => {
      this.handleUpdateSubMerchantEmail(id, newEmails);
    };

    const handleMobileUpdate = (id, newMobiles) => {
      this.handleUpdateSubMerchantMobile(id, newMobiles);
    };
    return (
      <div className='drawer_table'>
        <div className='drawer_search_area'>
          <span className='drawer_page_header'>
            Sub Merchants For {this.state.selectedMerchant}
          </span>
        </div>
        <div
          className={
            this.state.submerchantsData.length > 10
              ? 'drawer_table_content_page'
              : 'drawer_table_content'
          }
        >
          {' '}
          <CheckableDataTable
            tableData={this.state.slicedSubMerchants}
            tableheading={this.state.subMerchantTableheading}
            fetchError={this.state.subMerchantFetchError}
            renderTerminalsDropdown={this.renderTerminalsDropdown}
            handleCheck={this.handleCheckSubMerchants}
            handleSelectAll={this.handleCheckAllSubMerchants}
            handleMultipleCheck={() => { }}
            checkedRows={checkedRowsForCurrentMerchant}
            tag='subMerchants'
            handleLocationUpdate={this.handleUpdateSubMerchantLocation}
            handleEmailUpdate={handleEmailUpdate}
            handleMobileUpdate={handleMobileUpdate}
          />
        </div>
        {this.state.submerchantsData.length > 10 && (
          <Pagination
            pageCount={this.state.subMerchantPage}
            onChange={this.handleSubMerchantPagination}
            currentPage={0}
          />
        )}
        <div className='drawer_addBtn' style={{ marginBottom: '10px' }}>
          <Button
            variant='dark'
            block
            onClick={this.handleAddNewSubMerchantOnClick}
          >
            Add New Sub Merchant
          </Button>
        </div>
        <div className='drawer_addBtn'>
          <Button variant='dark' block onClick={this.handleTerminalsToPrint}>
            Add Sub Merchant to the Queue
          </Button>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className='root__div view_merchants'>
        {this.state.loading ? (
          <div className='spinner'>
            <Spinner animation='border' />
          </div>
        ) : (
          <div className='table'>
            <div className='search_area'>
              <PageHeader text='Merchants' />
              <div className='table_search'>
                <Search
                  placeholder='Merchant Name'
                  onBtnPress={this.handleMerchantNameSearch}
                  onClearPress={this.handlMerchantsclear}
                  max={50}
                />
                <Search
                  placeholder='Merchant ID'
                  onBtnPress={this.handleMerchantSearch}
                  onClearPress={this.handlMerchantsclear}
                  max={50}
                />
                <div className='buttonToolbarInline'>
                  <button
                    type='button'
                    className='merchant_icon_btn'
                    title='Filter merchants'
                    aria-label='Filter merchants'
                    onClick={() => {
                      this.setState({ showFilterModal: true });
                    }}
                  >
                    <FontAwesomeIcon icon={faFilter} />
                  </button>
                  <button
                    type='button'
                    className='merchant_icon_btn'
                    title='Terminal print queue'
                    aria-label='Terminal print queue'
                    onClick={this.toggleTerminalDetailsModal}
                  >
                    <FontAwesomeIcon icon={faFileDownload} />
                    {this.state.terminalsCount > 0 && (
                      <span className='countBadge'>
                        {this.state.terminalsCount}
                      </span>
                    )}
                  </button>

                  <SelectedTerminalsModal
                    show={this.state.showTerminalDetailsModal}
                    onClose={this.toggleTerminalDetailsModal}
                    clearTerminalQuantities={this.clearTerminalQuantities}
                    groupedTerminals={this.groupTerminalsByMerchant()}
                    terminalQuantities={this.state.terminalQuantities}
                    handleInputNumberChange={this.handleInputNumberChange}
                    printTerminalQuantities={this.printTerminalQuantities}
                    handleRemoveSubMerchantFromQueue={
                      this.handleRemoveSubMerchantFromQueue
                    }
                  />
                </div>
              </div>
            </div>
            <div className='merchants_table_wrapper'>
              <DataTable
                tableData={this.state.slicedData}
                tableheading={this.state.tableheading}
                handleOnClick={this.handleOnClick}
                fetchError={this.state.fetchError}
                notFoundMessage={
                  this.state.dataToRender.length === 0 &&
                  `No merchant ${this.state.searchedMerchantMessage}`
                }
                tag='merchants'
                handleEditMerchant={this.handleEditMerchant}
              />
            </div>
            <div className='merchants_pagination'>
              <Pagination
                pageCount={this.state.merchantPages}
                onChange={this.handleMerchantpagination}
                currentPage={0}
              />
            </div>
          </div>
        )}

        <Drawer
          size='md'
          show={this.state.merchantDrawer}
          onHide={() => this.handleDrawShow(false)}
        >
          {this.renderSubMerchantsDrawer()}
        </Drawer>
        <NewSubMerchantModal
          {...this.state}
          addNewSubMerchant={this.handleAddNewSubMerchant}
          toggleModalVisibility={this.handleModalShow}
          changeInputValue={this.handleOnChange}
          changePin={this.handlePinOnChange}
          toggleTextVisibility={this.handleTextVisibility}
        />
        <MerchantFilterModal
          show={this.state.showFilterModal}
          filterData={this.state.filterData}
          onFilter={this.handleFilter}
          toggleModalVisibility={() =>
            this.setState((prevState) => ({
              showFilterModal: !prevState.showFilterModal,
            }))
          }
        />

        <EditMerchantModal
          show={this.state.showEditMerchantModal}
          onHide={this.handleEditMerchantModalClose}
          merchant={this.state.merchantToEdit}
          token={this.props.auth.token}
          onSuccess={this.handleMerchantUpdateSuccess}
          categoryList={this.state.categoryList}
          statusList={this.state.statusList}
        />
      </div>
    );
  }
}

// Redux: map auth state to props
const mapStateToProps = (state) => {
  return {
    auth: state.auth.auth,
  };
};

export default connect(mapStateToProps)(ViewMerchants);
